import { useLayoutEffect, useState } from 'react';
import { ThemeContext } from '../../constants/themes';
import Type from '../../components/atoms/Type';
import Button from '../../components/atoms/Button';
import Loader from '../../components/atoms/Loader';
import Navbar from '../../components/molecules/Navbar';
import Authenticator from '../../components/molecules/Authenticator';
import TextSubmit from '../../components/molecules/TextSubmit';
import { withAuth0, useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Stripe from '../../api/stripe';
import './index.css';

const internalStripeApi = new Stripe();
  
const Settings = (props) => {
  const [state, setState] = useState({

  });

  const { logout } = useAuth0();

  const openBillingPortal = async () => {
    props.mixpanel?.track("Going to Manage Existing Stripe");
    const accessToken = await props.auth0.getAccessTokenSilently();
    internalStripeApi.openBillingPortal(accessToken).then(res => {
      if (res?.url !== undefined) {
        window.location.href = res.url;
      }
    });
  }

  return (
    <ThemeContext.Consumer>
      {themeContext => (
        <div className="background" style={{backgroundColor: themeContext.theme.body}}>
          <Navbar promptDashboard promptSettings={false} authed={props.auth0.isAuthenticated} />
          <div className="dashboard-content-div">
            <Type type="h1">Account settings</Type>
            <Button onClick={openBillingPortal} value="Manage subscription"></Button>
            <br/>
            <Button type="secondary" onClick={() => logout({ returnTo: window.location.origin })} value="Sign out"></Button>
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
}
  
export default withAuthenticationRequired(withAuth0(Settings), {
  // Show a message while the user waits to be redirected to the login page.
  onRedirecting: () => (
     <ThemeContext.Consumer>
        {themeContext => (
          <div className="background" style={{backgroundColor: themeContext.theme.body}}>
            <Navbar promptDashboard promptSettings={false} authed={true} />
            <div className="loading-background-small" style={{backgroundColor: themeContext.theme.body}}>
              <Loader />
            </div>
          </div>
        )}
     </ThemeContext.Consumer>
  )
});
  